import type { CompiledNavigationItem } from '@shared/types/domainConfig';

const HOME_KEY = 'home';
const MAX_TABS = 5;

const DEFAULT_HOME_TAB: CompiledNavigationItem = {
  id: 'home',
  system_key: HOME_KEY,
  label: 'Home',
  icon_url: '',
  route: '/app/home',
  module_key: HOME_KEY,
  placement: 'bottom_tab',
  order: 0,
};

/**
 * Bottom tabs from domain config must always lead with Home (member-portal parity).
 * Dedupes by `system_key`, sorts non-home tabs by `order`, caps at five slots.
 */
export function normalizeBottomTabs(tabs: CompiledNavigationItem[]): CompiledNavigationItem[] {
  const seen = new Set<string>();
  const unique: CompiledNavigationItem[] = [];

  for (const tab of tabs) {
    const key = (tab.system_key ?? '').trim().toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    unique.push(tab);
  }

  const home =
    unique.find((t) => t.system_key.trim().toLowerCase() === HOME_KEY) ?? DEFAULT_HOME_TAB;
  const rest = unique
    .filter((t) => t.system_key.trim().toLowerCase() !== HOME_KEY)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return [home, ...rest].slice(0, MAX_TABS);
}
